// Public descriptions. Sensor availability depends on the configured hardware.
// Keep actuator control and private telemetry out of the public presentation.
export const chaacFeatureGroups = [
  {
    title: "Klima und Pflanze verstehen",
    features: [
      "Lufttemperatur und relative Luftfeuchte erfassen und daraus den VPD berechnen – die Verdunstungsnachfrage der Luft.",
      "Je nach Ausstattung ergänzen Infrarot-Blatttemperatur, CO₂, Helligkeit und Spektralkanäle das Bild.",
      "Tag- und Nachtwerte sowie Wachstums- und Dry-&-Cure-Profile im lokalen Bedienbereich einstellen.",
    ],
  },
  {
    title: "VPD und VWC in einem Chaac",
    features: [
      "Externe, zugeordnete SenseCAP-Substratsensoren liefern den volumetrischen Wassergehalt (VWC) und je nach Sensortyp weitere Messwerte.",
      "Bis zu acht konfigurierte Sensor- und Bewässerungszonen verbinden Substratbeobachtung, Zeitfenster und Schwellwerte.",
      "Bewässerung über Zeitpläne oder den dafür eingerichteten SenseCAP-Bereich begleiten; Substrat und Sensor müssen passend kalibriert sein.",
    ],
  },
  {
    title: "Vor Ort steuern, Verlauf im Portal sehen",
    features: [
      "Chaac besitzt eine lokale WLAN-Oberfläche. Über passend eingerichtete Shelly-Aktoren kann es heizen, kühlen, be- und entfeuchten sowie die zugeordneten Bewässerungsaufgaben übernehmen.",
      "Die optionale Serveranbindung überträgt einen aktuellen Messframe pro Minute. Der Verlauf entsteht aus den tatsächlich empfangenen Daten.",
      "24 Stunden sind die Standardansicht; längere Zeiträume werden bewusst ausgewählt. Übertragungslücken bleiben erkennbar.",
    ],
  },
];

export const aeroponicFeatures = [
  {
    title: "Die Steuerung bleibt am System",
    text: "Ein STM32 steuert die Pumpe lokal. Am Touchdisplay werden Betriebszustand sowie Sprüh- und Pausenzeiten bedient. Begrenzungen, Überwachung und Abschaltung gehören zur Steuerungsarchitektur; die reale Anlage braucht eine geprüfte Inbetriebnahme.",
  },
  {
    title: "Zwei Luftwege, eine Messkammer",
    text: "Im gezeigten AeroFlo-Umbau sitzt das Messsystem in einem Netztopf. Dieselbe Messkammer kann zuerst Außenluft als Referenz und anschließend Luft aus dem Wurzelraum erfassen. Ein 5-V-BLDC fördert die Messluft. Diese Umschaltung dient der vergleichbaren Beobachtung; sie ist kein Verfahren zum Trocknen der Wurzeln.",
  },
  {
    title: "Sensoren mit klarer Aufgabe",
    text: "Eine RH/T-Messstelle erfasst relative Luftfeuchte und Temperatur in der Messkammer; eine zweite Messstelle kann den Pflanzenbereich ergänzen. Ein zusätzlicher Temperatureingang und ein optionaler Leaf-Rev4-Kanal gehören zu den weiteren Anschlüssen. Das Leaf-Signal ist kein direkt gemessener absoluter Turgordruck.",
  },
  {
    title: "Nährlösung beobachten",
    text: "EC IN und EC OUT sind getrennte Leitfähigkeitskanäle mit eigener Kalibrierung. Rohsignal, Kalibrierstand und Temperaturbezug müssen erkennbar bleiben. Eine EC-Differenz allein misst weder die Aufnahme einzelner Nährstoffe noch den Wasserverbrauch der Pflanze.",
  },
  {
    title: "Messungen nachvollziehen",
    text: "Ein eigener ESP32-Gateway verbindet die lokale Steuerung mit der Datenerfassung. Das Portal macht empfangene Messungen und Ereignisse nachvollziehbar. Chaac und seine Shelly-Aktoren bleiben ein eigener Steuerungsbereich.",
  },
  {
    title: "Schrittweise erproben",
    text: "Das Aeroponic-System befindet sich in Entwicklung und Erprobung. Zeitgesteuerter Betrieb und passive Messungen bilden die Grundlage. Adaptive Bewässerung ist ein experimentelles Entwicklungsziel und noch keine validierte pflanzenabhängige Regelung.",
  },
];

export const publicProductNotes = [
  "Chaac vereint Klima- und Substratfunktionen. VWC-Sensoren sind externe Komponenten; ein eigener VWC-Controller wird hier nicht als separates Produkt angeboten.",
  "Aus Licht- und Spektralsignalen abgeleitete PPFD-, ePPFD- und DLI-Werte bleiben Schätzungen, bis eine passende Referenzkalibrierung vorliegt.",
  "FEEDER setzt für seine Aeroponik auf ein steriles Betriebskonzept mit Reinigung, geeigneter Filtration und kontrollierter Hygiene. Gezielte Mikroorganismen-Zugaben gehören nicht zu diesem Konzept; ein keimfreier Zustand lässt sich aus einem Sensorwert nicht ableiten.",
  "Die bestätigte Anti-Tropf-Keramikdüse hat 0,2 mm Öffnung und laut Hersteller einen Arbeitsbereich von 12–20 bar. Die frühere Betreiberbeobachtung von etwa 25 bar mit zwölf Düsen ist kein freigegebener Betriebspunkt. Tröpfchenverteilung und Wirkung an der Pflanze sind separat zu messen.",
];
